import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
// import Link from '../Link'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import breakpointVariables from '../../Globals/breakpoints.module.css'
import { MapBoxMap } from 'components/MapBoxMap'
import { renderToString } from 'react-dom/server'
import './map.module.css'
import mapboxgl, { LngLatBoundsLike } from 'mapbox-gl'
import { ContentWidth } from 'components/Container'

var old_style = 'mapbox://styles/ta-interaktiv/cl5bzmcpw000914pv8zthhl8h/draft'
var new_style = 'mapbox://styles/ta-interaktiv/cljo92emv00g501pmawhu4h9l'
const isMobile = window.innerWidth < 712
type GdeDataType = {
  bbo: number[][]
  can: string
  gde: number
  nam: string
  cen: number[]
  vie: number[][]
  pow: number[]
  rad: number[]
}
// const settlementLabels = require('./settlements.json')
const gdedata = require('./gdedata.json') as GdeDataType[]
const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    breakpointVariables.globalBreakpoints,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const dataYear = +properties.dataYear || 2023
  const [map, setMap] = useState<mapboxgl.Map>()
  const [showMap, setShowMap] = useState(false)
  const [styleLoaded, setStyleLoaded] = useState(false)
  const [currentGdeNr, setcurrentGdeNr] = useState<number>()
  const [currentGde, setCurrentGde] = useState<GdeDataType>()
  const [currentBBox, setCurrentBbox] = useState<number[][]>()
  const [currentView, setCurrentView] = useState<number[][]>()
  const [settlementLabels, setSettlementLables] = useState<any>()
  const [mask, setMask] = useState<any>()

  useEffect(() => {
    const handleEvent = (event: CustomEvent) => {
      setcurrentGdeNr(event.detail)
    }
    window.addEventListener('changeGDE', handleEvent)
    console.log(properties)
    if (properties.gde) setcurrentGdeNr(+properties.gde)
    return () => {
      window.removeEventListener('changeGDE', handleEvent)
    }
  }, [])

  // Get Municipality Number from URL
  useEffect(() => {
    const searchParams = new URL(String(window.location)).searchParams
    const muniParam = searchParams.get('gemeinde')
    const bfsIdFromUrl = muniParam && parseInt(muniParam)

    if (bfsIdFromUrl) setcurrentGdeNr(bfsIdFromUrl)
  }, [])

  const handleGdeChange = () => {
    if (!map || !currentGde || !styleLoaded) return
    const solarfilter = [
      'all',
      ['match', ['get', 'gde'], [+currentGdeNr], true, false],
    ]
    /*

    Change gde mask

    */
    const doMapChanges = () => {
      let s = map.getSource('mask') as mapboxgl.GeoJSONSource
      map.setLayoutProperty('solar-sizes', 'visibility', 'visible')
      map.setFilter('solar-sizes', solarfilter)
      map.setMaxBounds(currentGde.bbo as LngLatBoundsLike)
      map.fitBounds(currentGde.vie as LngLatBoundsLike)
      if (map.getSource('settlements'))
        map.setFilter('settlements', solarfilter)
      if (
        currentGde &&
        currentGde.rad &&
        currentGde.rad[0] &&
        currentGde.rad[1]
      )
        map.setPaintProperty('solar-sizes', 'circle-radius', [
          'interpolate',
          ['linear'],
          ['get', 'rad'],
          currentGde.rad[0],
          5,
          currentGde.rad[1],
          isMobile ? 30 : 50,
        ])
      s.setData(mask)
    }

    //  doMapChanges()
    // if (map && !styleLoaded)
    map.once('styledata', () => {
      doMapChanges()
    })
    map.once('idle', () => {
      doMapChanges()
    })
    // map.once('idle', () => {

    // })

    // fetch(
    //   'https://interaktiv.tagesanzeiger.ch/static/2022/solar-karte/' +
    //     currentGdeNr +
    //     '.json'
    // )
    //   .then((a) => a.json())
    //   .then((mask_) => {
    //     map.once('idle', () => {
    //       let s = map.getSource('mask') as mapboxgl.GeoJSONSource
    //       map.setLayoutProperty('solar-sizes', 'visibility', 'visible')
    //       map.setFilter('solar-sizes', solarfilter)
    //       map.setMaxBounds(currentGde.bbo as LngLatBoundsLike)
    //       map.fitBounds(currentGde.vie as LngLatBoundsLike)
    //       s.setData(mask_)
    //     })
    //   })
    /*
   
   Set filter for solars

    */
    //  setCurrentView(currentGde.vie)
    //  setCurrentBbox(currentGde.bbo)
    // map.setFilter('solar-lines', solarfilter)
    // map.setFilter('solar-sizes', solarfilter)
    // map.setMaxBounds(currentGde.bbo as LngLatBoundsLike)
    // map.fitBounds(currentGde.vie as LngLatBoundsLike)

    /*

    Set new Bounding Box

    */
  }

  useEffect(() => {
    if (!map) return
    map.setPaintProperty(
      'mask',
      'fill-color',
      colorMode === 'light' ? '#fff' : '#121212'
    )
  }, [colorMode])

  // Add City Labels to Map
  // useEffect(() => {
  //   if (!map) return
  //   map.once('idle', () => {
  //     if (!map.getSource('settlements'))
  //       map.addSource('settlements', {
  //         type: 'geojson',
  //         data: settlementLabels,
  //       })
  //     if (!map.getLayer('settlements'))
  //       map.addLayer(
  //         {
  //           id: 'settlements',
  //           type: 'symbol',
  //           source: 'settlements',
  //           layout: {
  //             'text-field': ['get', 'nam'],
  //             'text-font': ['Source Sans Pro Regular', 'Arial Unicode MS Bold'],
  //             'text-size': 18,
  //             'text-offset': [0, 0],
  //             'text-anchor': 'left',
  //             'text-letter-spacing': 0.025,
  //           },
  //           paint: {
  //             'text-halo-color': '#202346',
  //             'text-color': '#fff',
  //             'text-halo-width': 1,
  //             'text-halo-blur': 1,
  //           },
  //         },
  //         'solar-sizes'
  //       )
  //     map.setFilter('settlements', [
  //       'all',
  //       ['match', ['get', 'gde'], [currentGdeNr], true, false],
  //     ])
  //   })
  // }, [settlementLabels])

  // Get City Label Data
  useEffect(() => {
    if (!map) return
    fetch(
      'https://interaktiv.tagesanzeiger.ch/static/2022/solar-karte/settlements.json'
    )
      .then((a) => a.json())
      .then((settlementLabels) => {
        setSettlementLables(settlementLabels)
      })
  }, [map])

  // Change Municipality
  useEffect(() => {
    // if (!map || !styleLoaded || !currentGde) return
    if (currentGde) {
      if (currentGde.pow) {
        setShowMap(true)
      } else {
        setShowMap(false)
      }
      setCurrentView(currentGde.vie)
      setCurrentBbox(currentGde.bbo)
      handleGdeChange()
    }
  }, [currentGde, mask, settlementLabels, map, styleLoaded])

  useEffect(() => {
    /*

    Find gde with gde number in gdedata

    */
    fetch(
      'https://interaktiv.tagesanzeiger.ch/static/2022/solar-karte/' +
        currentGdeNr +
        '.json'
    )
      .then((a) => a.json())
      .then((mask_) => {
        setMask(mask_)
      })
    let gde: GdeDataType | undefined = gdedata.find(
      (f) => f.gde === +currentGdeNr
    )

    if (!gde) return
    setCurrentGde(gde)
  }, [currentGdeNr])

  if (!showMap) return null
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <ContentWidth>
        {currentGdeNr && (
          <MapBoxMap
            language={tenant.lang}
            panAllowed
            dataSource='BFE, SwissTopo'
            maxExtendBounds={currentBBox}
            viewBounds={currentView}
            init={(map: mapboxgl.Map) => {
              setMap(map)

              map.once('styledata', () => {
                map.on('click', 'solar-sizes', (e) => {
                  // Copy coordinates array.
                  const coordinates =
                    e.features[0].geometry['coordinates'].slice()
                  const props = e.features[0].properties

                  // // Ensure that if the map is zoomed out such that multiple
                  // // copies of the feature are visible, the popup appears
                  // // over the copy being pointed to.
                  // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                  // coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                  // }

                  new mapboxgl.Popup({
                    closeButton: false,
                    className: 'popppp',
                  })

                    .setLngLat(coordinates)
                    .setHTML(
                      renderToString(
                        <PopUp
                          year={props.year}
                          power={+props.pow}
                          language={tenant.lang}
                        />
                      )
                    )
                    // .setHTML('<div><b>' + props.year + '</b></div>')
                    .addTo(map)
                })
              })
              map.on('styledata', function () {
                setStyleLoaded(true)

                let s = map.getSource('mask')
                if (!s)
                  map.addSource('mask', {
                    type: 'geojson',
                    data: {
                      type: 'Feature',
                      properties: {},
                      geometry: {
                        type: 'Polygon',
                        coordinates: [
                          [
                            [-180, -90],
                            [-180, 90],
                            [180, 90],
                            [180, -90],
                            [-180, -90],
                          ],
                        ],
                      },
                    },
                  })

                let l = map.getLayer('mask')
                if (!l)
                  map.addLayer(
                    {
                      id: 'mask',
                      type: 'fill',
                      source: 'mask',
                      layout: {},
                      paint: {
                        'fill-color':
                          colorMode === 'light' ? '#fff' : '#121212',
                        'fill-opacity': 1,
                        // 'fill-pattern': 'hatched_1',
                      },
                    },
                    'solar-sizes'
                  )
              })
            }}
            config={{
              dragRotate: true,
              pitch: 50,
              // maxPitch: 40,
              style: dataYear === 2023 ? new_style : old_style,
            }}
          />
        )}
      </ContentWidth>
    </AppContainer>
  )
}

const PopUp = ({
  year,
  power,
  language,
}: {
  year: number
  power: number
  language: 'de' | 'fr' | undefined
}) => {
  const Labels = {
    de: { year: 'Baujahr', power: 'Leistung', unit: 'kWp' },
    fr: { year: 'Année de construction', power: 'Performance', unit: 'kWc' },
  }
  return (
    <StyledPopUp>
      <div className='row'>
        <label>{Labels[language].year}:</label> <b>{year}</b>
      </div>
      <div className='row'>
        <label>{Labels[language].power}:</label>{' '}
        <b>
          {power}
          {Labels[language].unit}
        </b>
      </div>
    </StyledPopUp>
  )
}
const StyledPopUp = styled.div`
  font-size: 14px;
  line-height: 1.4em;
  font-family: var(--font-plex);
  font-weight: 500;
  .row {
    width: 100%;
  }
  label {
    /* font-size: 12px; */
    font-weight: 400;
    margin-right: 1em;
  }
`
const AppContainer = styled.div<{ tenant?: string }>`
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: var(--font-plex);
  color: var(--brandblue-main);
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-bottom: 60px;
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
`
export default MainComponent
